import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ChildrenIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ChildrenGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M13.5684 17.6965H7.09573C6.9481 17.6965 6.80789 17.6323 6.71162 17.5198C6.61584 17.4072 6.57338 17.2591 6.59609 17.113L7.08833 13.9601L6.1873 14.7757C5.56768 15.3395 4.51902 15.2872 3.9542 14.6641C3.67032 14.3511 3.52565 13.9463 3.54639 13.5236C3.56762 13.102 3.75177 12.7129 4.06529 12.4295L7.0197 9.75754C7.31001 9.4939 7.68722 9.34874 8.08071 9.34874H12.5829C12.9764 9.34874 13.3536 9.49389 13.6444 9.75852L16.5988 12.4295C17.2456 13.0151 17.296 14.0173 16.7109 14.6631C16.1466 15.2872 15.0989 15.3395 14.4768 14.7747L13.5758 13.9601L14.0681 17.1129C14.0908 17.2591 14.0483 17.4072 13.9525 17.5198C13.8562 17.6323 13.716 17.6965 13.5684 17.6965ZM7.68622 16.6854H12.9779L12.3563 12.705C12.3232 12.4937 12.4274 12.2844 12.6155 12.1817C12.8036 12.08 13.0362 12.1076 13.1951 12.2518L15.1557 14.0252C15.3803 14.2296 15.757 14.2089 15.9619 13.9848C16.1723 13.7527 16.154 13.3913 15.9205 13.18L12.9655 10.508C12.8604 10.4122 12.7246 10.3599 12.5829 10.3599H8.08069C7.93899 10.3599 7.80322 10.4122 7.69855 10.507L4.74365 13.18C4.63058 13.2817 4.56394 13.4219 4.55653 13.574C4.54863 13.726 4.60096 13.8722 4.70316 13.9848C4.90707 14.2099 5.28477 14.2287 5.50842 14.0262L7.46897 12.2518C7.62795 12.1076 7.85901 12.08 8.0486 12.1817C8.23671 12.2844 8.34087 12.4937 8.3078 12.705L7.68622 16.6854Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.4054 20.9995C10.9912 20.9995 10.614 20.8395 10.3321 20.5779C10.0501 20.8395 9.67294 20.9995 9.25872 20.9995C8.3883 20.9995 7.67981 20.2915 7.67981 19.4206V17.191C7.67981 16.9115 7.90593 16.6854 8.18538 16.6854C8.46483 16.6854 8.69095 16.9115 8.69095 17.191V19.4206C8.69095 19.7336 8.94571 19.9884 9.25872 19.9884C9.57174 19.9884 9.8265 19.7336 9.8265 19.4206C9.8265 19.1412 10.0526 18.915 10.3321 18.915C10.6115 18.915 10.8376 19.1412 10.8376 19.4206C10.8376 19.7336 11.0924 19.9884 11.4054 19.9884C11.7189 19.9884 11.9737 19.7336 11.9737 19.4206V17.191C11.9737 16.9115 12.1998 16.6854 12.4792 16.6854C12.7587 16.6854 12.9848 16.9115 12.9848 17.191V19.4206C12.9848 20.2915 12.2763 20.9995 11.4054 20.9995Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.3321 19.9262C10.0526 19.9262 9.8265 19.7001 9.8265 19.4206V17.2996C9.8265 17.0201 10.0526 16.794 10.3321 16.794C10.6115 16.794 10.8376 17.0201 10.8376 17.2996V19.4206C10.8376 19.7001 10.6115 19.9262 10.3321 19.9262Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.229 12.6425C10.4785 12.6425 10.6808 12.4402 10.6808 12.1907C10.6808 11.9411 10.4785 11.7389 10.229 11.7389C9.97942 11.7389 9.77712 11.9411 9.77712 12.1907C9.77712 12.4402 9.97942 12.6425 10.229 12.6425Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.229 14.5733C10.4785 14.5733 10.6808 14.371 10.6808 14.1214C10.6808 13.8719 10.4785 13.6696 10.229 13.6696C9.97942 13.6696 9.77712 13.8719 9.77712 14.1214C9.77712 14.371 9.97942 14.5733 10.229 14.5733Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.2289 8.73653C8.75216 8.73653 7.55094 7.53481 7.55094 6.05859C7.55094 4.58237 8.75216 3.38066 10.2289 3.38066C11.7056 3.38066 12.9068 4.58237 12.9068 6.05859C12.9068 7.53481 11.7056 8.73653 10.2289 8.73653ZM10.2289 4.3918C9.30957 4.3918 8.56208 5.13929 8.56208 6.05859C8.56208 6.9779 9.30957 7.72539 10.2289 7.72539C11.1482 7.72539 11.8957 6.9779 11.8957 6.05859C11.8957 5.13929 11.1482 4.3918 10.2289 4.3918Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.0628 6.07341C12.2156 6.07341 11.5264 5.38417 11.5264 4.53695C11.5264 3.68874 12.2156 2.99951 13.0628 2.99951C13.9105 2.99951 14.5998 3.68874 14.5998 4.53695C14.5998 5.38417 13.9105 6.07341 13.0628 6.07341ZM13.0628 4.01065C12.773 4.01065 12.5375 4.24665 12.5375 4.53695C12.5375 4.82627 12.773 5.06227 13.0628 5.06227C13.3526 5.06227 13.5886 4.82627 13.5886 4.53695C13.5886 4.24665 13.3526 4.01065 13.0628 4.01065Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.38407 6.07341C6.53635 6.07341 5.84712 5.38417 5.84712 4.53695C5.84712 3.68874 6.53635 2.99951 7.38407 2.99951C8.23178 2.99951 8.92101 3.68874 8.92101 4.53695C8.92101 5.38417 8.23178 6.07341 7.38407 6.07341ZM7.38407 4.01065C7.09425 4.01065 6.85825 4.24665 6.85825 4.53695C6.85825 4.82627 7.09425 5.06227 7.38407 5.06227C7.67388 5.06227 7.90988 4.82627 7.90988 4.53695C7.90988 4.24665 7.67388 4.01065 7.38407 4.01065Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.7689 11.0313C17.6559 11.0313 17.5423 10.9938 17.4495 10.9178C17.3453 10.8329 14.9029 8.81652 14.9029 6.61749C14.9029 5.03759 16.1886 3.75195 17.7689 3.75195C19.3493 3.75195 20.635 5.03759 20.635 6.61749C20.635 8.81651 18.1926 10.8329 18.0884 10.9178C17.9956 10.9938 17.882 11.0313 17.7689 11.0313ZM17.7689 4.76307C16.746 4.76307 15.9141 5.5945 15.9141 6.61748C15.9141 7.92584 17.1641 9.27171 17.7689 9.8464C18.3738 9.27171 19.6238 7.92584 19.6238 6.61748C19.6238 5.59449 18.7919 4.76307 17.7689 4.76307Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.4784 14.6266C16.4216 14.6266 16.3638 14.6167 16.3075 14.597C16.0449 14.5022 15.9081 14.2128 16.0024 13.9502L17.293 10.3549C17.3868 10.0913 17.6771 9.95798 17.9398 10.0498C18.2024 10.1446 18.3392 10.4339 18.2449 10.6966L16.9543 14.2918C16.8803 14.4982 16.6857 14.6266 16.4784 14.6266Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.592 6.65402C9.83093 6.65402 8.65835 5.49971 8.24461 4.79171C8.1039 4.55078 8.18488 4.2417 8.42581 4.10051C8.66625 3.95733 8.97532 4.04027 9.11653 4.28022C9.15898 4.35131 10.182 6.0191 12.2941 5.56487C12.5671 5.50464 12.8362 5.67843 12.8955 5.95097C12.9547 6.22449 12.7814 6.49307 12.5084 6.55232C12.1875 6.62243 11.8818 6.65402 11.592 6.65402Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ChildrenIcon;
